module.exports = __webpack_public_path__ + "img/ApfelEssen.e6972529.jpg";